var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/*
eslint-disable
 */
import React from 'react';
export function PositionHandler(_a) {
    var positionStyle = _a.positionStyle, children = _a.children, instance = _a.instance;
    var fixedWidth = instance && instance.fixedWrapperStyle && instance.fixedWrapperStyle.width;
    var fixedHeight = instance && instance.fixedWrapperStyle && instance.fixedWrapperStyle.height;
    var commonWidth = instance && instance.commonStyle && instance.commonStyle.width;
    var styleOBj = __assign(__assign({}, positionStyle), { width: fixedWidth || (commonWidth ? 'auto' : '100%'), height: fixedHeight || 'auto', zIndex: 999 });
    return React.createElement("div", { style: styleOBj }, children);
}
//# sourceMappingURL=PositionHandler.js.map